module.exports = __webpack_public_path__ + "static/img/imgNutriologa.2e710ef3.webp";